'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of social
 */ const Social = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M23.8555 50.5958C23.8555 54.4337 26.9362 57.5432 30.7327 57.5432C34.5291 57.5432 37.6099 54.4337 37.6099 50.5958C37.6099 46.7579 34.5318 43.6484 30.7327 43.6484C26.9336 43.6484 23.8555 46.7579 23.8555 50.5958Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M36.6406 59.373C34.9523 60.5252 32.9169 61.2001 30.7264 61.2001C28.5358 61.2001 26.4978 60.5252 24.8121 59.373C21.4829 61.2476 19.2266 64.82 19.2266 68.9144V70.3381C19.2266 71.8883 20.4809 73.1274 22.0088 73.1274H36.8168V72.471C36.8168 68.8063 38.1816 65.4501 40.4195 62.8954C39.4623 61.4427 38.1632 60.2325 36.6406 59.373Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M73.2639 43.6484C69.4648 43.6484 66.3867 46.7579 66.3867 50.5958C66.3867 54.4337 69.4674 57.5432 73.2639 57.5432C77.0604 57.5432 80.1411 54.4337 80.1411 50.5958C80.1411 46.7579 77.063 43.6484 73.2639 43.6484Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M79.1925 59.3757C77.5028 60.5276 75.4656 61.2024 73.2731 61.2024C71.0806 61.2024 69.0408 60.5276 67.3511 59.373C65.8324 60.2271 64.5375 61.4291 63.582 62.8789C65.8219 65.4305 67.1879 68.786 67.1879 72.4711V73.1274H81.9903C83.538 73.1274 84.775 71.8885 84.775 70.3386V68.9152C84.775 64.8189 82.5246 61.2498 79.1925 59.3757Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M45.0547 54.1682C45.0547 57.9673 48.1668 61.0454 52.0021 61.0454C55.8373 61.0454 58.9494 57.9673 58.9494 54.1682C58.9494 50.3691 55.8399 47.291 52.0021 47.291C48.1642 47.291 45.0547 50.3691 45.0547 54.1682Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M57.9552 62.873C56.2548 64.0245 54.2046 64.6991 51.9982 64.6991C49.7918 64.6991 47.7391 64.0245 46.0386 62.873C42.6853 64.7439 40.418 68.3089 40.418 72.4063V73.8344C40.418 75.3785 41.6761 76.6274 43.2256 76.6274H60.7682C62.3177 76.6274 63.5759 75.3758 63.5759 73.8344V72.4063C63.5759 68.3089 61.3085 64.7439 57.9552 62.873Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M45.0547 54.1682C45.0547 57.9673 48.1668 61.0454 52.0021 61.0454C55.8373 61.0454 58.9494 57.9673 58.9494 54.1682C58.9494 50.3691 55.8399 47.291 52.0021 47.291C48.1642 47.291 45.0547 50.3691 45.0547 54.1682Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M57.9552 62.873C56.2548 64.0245 54.2046 64.6991 51.9982 64.6991C49.7918 64.6991 47.7391 64.0245 46.0386 62.873C42.6853 64.7439 40.418 68.3089 40.418 72.4063V73.8344C40.418 75.3785 41.6761 76.6274 43.2256 76.6274H60.7682C62.3177 76.6274 63.5759 75.3758 63.5759 73.8344V72.4063C63.5759 68.3089 61.3085 64.7439 57.9552 62.873Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M65.1167 34.8173V25.9601C65.1167 23.8702 63.4179 22.1777 61.3202 22.1777H42.6676C40.5699 22.1777 38.8711 23.8702 38.8711 25.9601V34.8173C38.8711 36.9072 40.5699 38.5997 42.6676 38.5997H48.2423L50.6438 42.8638C51.2356 43.914 52.7522 43.914 53.344 42.8638L55.7455 38.5997H61.3202C63.4179 38.5997 65.1167 36.9072 65.1167 34.8173ZM51.9913 28.2711C53.1643 28.2711 54.1181 29.2214 54.1181 30.3874C54.1181 31.5534 53.1643 32.5063 51.9913 32.5063C50.8182 32.5063 49.8671 31.5561 49.8671 30.3874C49.8671 29.2187 50.8209 28.2711 51.9913 28.2711ZM44.7812 32.5063C43.6108 32.5063 42.6544 31.5561 42.6544 30.3874C42.6544 29.2187 43.6108 28.2711 44.7812 28.2711C45.9517 28.2711 46.9081 29.2214 46.9081 30.3874C46.9081 31.5534 45.9543 32.5063 44.7812 32.5063ZM59.2066 32.5063C58.0335 32.5063 57.0797 31.5561 57.0797 30.3874C57.0797 29.2187 58.0335 28.2711 59.2066 28.2711C60.3796 28.2711 61.3334 29.2214 61.3334 30.3874C61.3334 31.5534 60.3796 32.5063 59.2066 32.5063Z",
                fill: theme.ds5.asset[assetColor]["100"]
            })
        ]
    });
};

exports.Social = Social;
//# sourceMappingURL=Social.cjs.map
